import * as React from 'react';
/**
 *
 * Original name: mic
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=3704%3A534
 *
 */
export const MicSpot = (props) => (React.createElement("svg", { viewBox: "0 0 120 120", fill: "none", ...props },
    React.createElement("path", { d: "M60 77c13.542 0 21-7.458 21-21V34c0-13.542-7.458-21-21-21s-21 7.458-21 21v22c0 13.542 7.458 21 21 21Zm0-58c8.254 0 13.034 3.285 14.5 10H66v6h9v7h-9v6h9v7h-9v6h8.5c-1.47 6.715-6.251 10-14.5 10-8.249 0-13.034-3.285-14.5-10H54v-6h-9v-7h9v-6h-9v-7h9v-6h-8.5c1.466-6.715 6.246-10 14.5-10Z", fill: "currentColor" }),
    React.createElement("path", { d: "M98 55.621h-6C92 77.106 81.233 88 60 88S28 77.106 28 55.621h-6c0 23.718 12.4 37.215 35 38.3V107h6V93.92c22.6-1.085 35-14.582 35-38.299Z", fill: "currentColor" })));
